export const TRANSLATION_MODE = {
  TRANSLATE: 'TRANSLATE',
  CONVERT: 'CONVERT',
  MIRROR: 'MIRROR',
};

export const TRANSLATION_POWER = {
  QWEN: 'QWEN',
};
export const MODAL_TYPE = {
  SOURCE: 'SOURCE',
};

export const getTranslationModeOptions = (getI18n: (key: string) => string) => [
  {
    label: getI18n('salesChannelLanguage.index.translate'),
    value: TRANSLATION_MODE.TRANSLATE,
  },
  {
    label: getI18n('salesChannelLanguage.index.convert'),
    value: TRANSLATION_MODE.CONVERT,
  },
  {
    label: getI18n('salesChannelLanguage.index.mirror'),
    value: TRANSLATION_MODE.MIRROR,
  },
];

export const translationPowerOptions = [
  { label: 'QWEN', value: TRANSLATION_POWER.QWEN },
];
